import { render, staticRenderFns } from "./PAYGUsageSettings.vue?vue&type=template&id=66cce3ac&"
import script from "./PAYGUsageSettings.vue?vue&type=script&lang=js&"
export * from "./PAYGUsageSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports